import { render, staticRenderFns } from "./stock.vue?vue&type=template&id=5829665e&scoped=true"
import script from "./stock.vue?vue&type=script&lang=ts"
export * from "./stock.vue?vue&type=script&lang=ts"
import style0 from "./stock.vue?vue&type=style&index=0&id=5829665e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5829665e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5829665e')) {
      api.createRecord('5829665e', component.options)
    } else {
      api.reload('5829665e', component.options)
    }
    module.hot.accept("./stock.vue?vue&type=template&id=5829665e&scoped=true", function () {
      api.rerender('5829665e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory-inwards/stock.vue"
export default component.exports